import React from 'react';
import qs from 'query-string';
import { navigate } from 'gatsby-link';

import searchIcon from '../../_assets/images/search-icon.png';
import Prefectures from '../../_data/prefectures';

import { jobtypeConstants } from '../../_constants/job.type.constants';
import { jobworkingdayConstants } from '../../_constants/job.working.day.constants';

const initialState = {
  prefecture: '',
  ward: '',
  type: '',
  wday: '',
  whour: '',
  estatus: '',
  salary: 0,
};

class JobSimpleSearch extends React.Component {
  constructor(props) {
    super(props);

    this.state = initialState;
  }

  async componentWillReceiveProps(nextProps) {
    await this.setState(initialState);
    const { params } = nextProps;
    if (!params) return;
    if (params.prefecture !== undefined)
      this.setState({ prefecture: params.prefecture });
    if (params.ward !== undefined) this.setState({ ward: params.ward });
    if (params.type !== undefined) this.setState({ type: params.type });
    if (params.wday !== undefined) this.setState({ wday: params.wday });
    if (params.whour !== undefined) this.setState({ whour: params.whour });
    if (params.estatus !== undefined)
      this.setState({ estatus: params.estatus });
    if (params.salary) this.setState({ salary: parseInt(params.salary, 10) });
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  handleSubmit = (e) => {
    const searchString = qs.stringify(this.state);
    navigate(`/jobs${searchString ? `?${searchString}` : ''}`);
    e.preventDefault();
  };

  render() {
    return (
      <React.Fragment>
        <div className="col-12 job-search-title">
          <span className="job-search-title-icon">
            <img src={searchIcon} alt="search" width={18} />
          </span>
          求人情報を探す
        </div>

        <div className="row mx-0 job-search job-search-simple">
          <span className="job-search-anchor" />
          {/*  */}
          <div className="col-12 job-search-content">
            {/*  */}
            <div className="col-12 mx-0 px-0">
              <div className="job-search-formgroup row col-12 mx-0 pt-3">
                {/* 都道府県 */}
                <div className="col-4 pl-0">
                  <label className="job-search-formgroup-label">都道府県</label>
                  <div className="job-search-formgroup-select-wrap">
                    <select
                      onChange={this.handleChange}
                      name="prefecture"
                      value={this.state.prefecture}
                      className="form-control job-search-formgroup-select">
                      <option value="">すべて</option>
                      {Prefectures.map((pref) => (
                        <option key={pref.slug} value={pref.name}>
                          {pref.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                {/* 職種 */}
                <div className="col-4 pl-0">
                  <label className="job-search-formgroup-label">職種</label>
                  <div className="job-search-formgroup-select-wrap">
                    <select
                      onChange={this.handleChange}
                      name="type"
                      value={this.state.type}
                      className="form-control job-search-formgroup-select">
                      <option value="">すべて</option>
                      {jobtypeConstants.map((type, index) => (
                        <option key={index} value={index}>
                          {type}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                {/* 勤務日数 */}
                <div className="col-4 pl-0 pr-0">
                  <label className="job-search-formgroup-label">勤務日数</label>
                  <div className="job-search-formgroup-select-wrap">
                    <select
                      onChange={this.handleChange}
                      name="wday"
                      value={this.state.wday}
                      className="form-control job-search-formgroup-select">
                      <option value="">すべて</option>
                      {jobworkingdayConstants.map((working_days, index) => (
                        <option key={index} value={index}>
                          {working_days}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
              {/* button */}
              <div className="row col-12 mx-0 job-search-formgroup-button mt-4 justify-content-center align-items-center">
                <button
                  className="btn"
                  type="button"
                  onClick={this.handleSubmit}>
                  この条件で検索する
                </button>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default JobSimpleSearch;
